var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "from-sh-product" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "fa-tag-icon" }, [
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c("font-awesome-icon", {
            attrs: { icon: ["fas", "tag"], size: "lg" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "m-0" }, [_vm._v(_vm._s(_vm.title))]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [
      _c("p", { staticClass: "m-0" }, [_vm._v("Designing for:")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }